// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","header_headercontainer":"Header_header_headercontainer__TfxHr"};